import React from 'react';

export const AuthContext = React.createContext({
    user: null,
    userProfile: null,
    loading: true,
    error: null,
    login: () => { },
    register: () => { },
    logout: () => { },
    updateProfile: () => { },
    updateUserProfile: () => { },
    isAdmin: false,
    isStudent: false,
    isStartup: false,
});

export default AuthContext;
